import 'jquery-colorbox';
import { URLASSOLUTO } from './variables';

jQuery(function() {

    $(".colorbox").colorbox({ maxWidth: "90%", maxHeight: "90%" });
    $(".colorboxtube").colorbox({ iframe: true, innerWidth: "90%", innerHeight: "90%", maxWidth: "90%" });
    $(".privacypop").colorbox({iframe: true, href: URLASSOLUTO + "/privacy-policy-iframe.html", innerWidth: '95%', innerHeight: 450 });

});